import { Routes } from '@angular/router';

import { azureTenantsSegments } from '@advania-cosoftware/wolf-router';

export const azureTenantsRoutes: Routes = [
    {
        path: azureTenantsSegments.azureTenants,
        loadComponent: () => import('./pages/azure-tenants-page/azure-tenants.page').then((m) => m.AzureTenantsPage),
    },
    {
        path: `${azureTenantsSegments.azureTenants}/:azureTenantId`,
        loadComponent: () => import('./pages/azure-tenant-page/azure-tenant.page').then((m) => m.AzureTenantPage),
    },
];
